/**
 * Multi-tab query cache sync via BroadcastChannel.
 *
 * When one tab invalidates a query key (e.g. after a new chat, pin toggle,
 * or generation), the other open tabs receive the same invalidation so their
 * sidebar / message list stays up-to-date without a manual refresh.
 */

const CHANNEL_NAME = 'photon-query-sync';

let channel = null;
let listening = false;

export function setupBroadcastSync(queryClient) {
  if (typeof BroadcastChannel === 'undefined') return; // SSR / unsupported browser

  channel = new BroadcastChannel(CHANNEL_NAME);

  // Receive invalidations from other tabs
  channel.onmessage = (event) => {
    const { type, queryKey } = event.data || {};
    if (type === 'invalidate' && queryKey) {
      queryClient.invalidateQueries({ queryKey });
    }
  };

  listening = true;
}

/**
 * Broadcast a query invalidation to all other open tabs.
 * Call this _after_ the local invalidateQueries so the originating tab
 * doesn't double-fire.
 */
export function broadcastInvalidate(queryKey) {
  if (!channel || !listening) return;
  try {
    channel.postMessage({ type: 'invalidate', queryKey });
  } catch {
    // Channel may be closed — ignore
  }
}
